import { Box, Typography, Select, MenuItem, Card, styled } from "@mui/material";
import Colors from "../../theme/Colours";

export const FiltersSection = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor: Colors.background2,
  borderRadius: "4px 4px 0px 0px",
  padding: "16px",
  border: `0.96px solid ${Colors.filterBorder}`,
  borderBottom: "none",
});

export const FiltersRight = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "15.39px",
});

export const FilterSection = styled(Box)({
  display: "flex",
  alignItems: "center",
  minWidth: "140px",
  height: "40px",
  borderRadius: "4px",
  background: Colors.background2,
  cursor: "pointer",
});

export const StyledSelect = styled(Select)({
  width: "100%",
  height: "100%",
  fontFamily: "Poppins, sans-serif",
  fontSize: "12px",
  fontWeight: 600,
  color: Colors.searchInputText,
  backgroundColor: Colors.background2,
  borderRadius: "4px",

  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: Colors.searchInputBorder,
  },

  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: Colors.searchInputBorder,
  },

  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: Colors.searchInputBorder,
  },
});

export const FilterMenuItem = styled(MenuItem)({
  fontSize: "12px",
  display: "flex",
  alignItems: "center",
  gap: "4px",
  fontWeight: 500,
  color: Colors.searchInputText,
  padding: "6px 20px 6px 12px",
  fontFamily: "Poppins, sans-serif",

  "&:hover": {
    backgroundColor: "#eeeeee",
  },
});

export const ExportButton = styled(Box)({
  display: "flex",
  alignItems: "center",
  height: "40px",
  boxSizing: "border-box",
  gap: "6px",
  padding: "8px 12px",
  border: `0.96px solid ${Colors.searchInputBorder}`,
  borderRadius: "4px",
  backgroundColor: Colors.background2,
  cursor: "pointer",
  transition: "background-color 0.2s ease",

  "&:hover": {
    backgroundColor: Colors.lightBackground,
  },
});

export const FilterButton = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "6px",
});

export const StyledCard = styled(Card)({
  borderRadius: "0px 0px 4px 4px",
  border: `0.96px solid ${Colors.filterBorder}`,
});

export const CustomerName = styled(Typography)({
  color: "#101828",
  cursor: "pointer",
  fontWeight: "500",
  fontSize: "14px",
  fontFamily: "Poppins, sans-serif",
});

export const LocationText = styled(Typography)({
  width: "180px",
  fontWeight: 400,
  color: Colors.tableFieldText,
  fontSize: "14px",
  fontFamily: "Poppins, sans-serif",
  overflow: "hidden",
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  textOverflow: "ellipsis",
  wordBreak: "break-word",
  whiteSpace: "normal",
});

export const OrderIdText = styled("span")({
  fontSize: "11px",
  color: Colors.tableFieldText,
  fontFamily: "Poppins, sans-serif",
});

export const OrderPriceText = styled("span")({
  fontSize: "11px",
  fontFamily: "Poppins, sans-serif",
});

export const PaymentStatusText = styled(Typography)({
  fontWeight: 400,
  fontSize: "13.46px",
  color: Colors.tableFieldText,
  fontFamily: "Poppins, sans-serif",
});

export const OrderStatusText = styled(Typography)({
  fontWeight: 500,
  fontSize: "14px",
  color: "#101010",
  fontFamily: "Poppins, sans-serif",
});

export const OrderDetailsContainer = styled("span")({
  display: "flex",
  flexDirection: "column",
});

export const FilterExportText = styled(Typography)({
  fontSize: "13.46px",
  color: Colors.searchInputText,
  fontWeight: "500",
});

export const TableLabelStyle = {
  fontSize: "11.54px",
  color: Colors.tableFieldText,
  fontWeight: "500",
  backgroundColor: Colors.tableLabelBackground,
};

export const TableRowStyle = {
  height: "80px",
  cursor: "pointer",
};

export const StyledMenuPaper = {
  borderRadius: "4px",
  border: `1px solid ${Colors.searchInputBorder}`,
  width: "160px",
  marginTop: "4px",
  fontFamily: "Poppins, sans-serif",
};
